import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSilencer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 30,
	viewBox: "0 0 100.0 30.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 3.0 10.0 L 20.0 10.0 A 10.0 10.0 0.0 0 1 30.0 0.0 L 70.0 0.0 A 10.0 10.0 0.0 0 1 80.0 10.0 L 97.0 10.0 L 97.0 20.0 L 80.0 20.0 A 10.0 10.0 0.0 0 1 70.0 30.0 L 30.0 30.0 A 10.0 10.0 0.0 0 1 20.0 20.0 L 3.0 20.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 5.0 L 0.0 25.0 M 3.0 5.0 L 3.0 25.0 M 100.0 5.0 L 100.0 25.0 M 97.0 5.0 L 97.0 25.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgSilencer;
